import Masonry from 'masonry-layout';

const initMasonry = (itemWidth) => {
    /* eslint-disable */
    const $masonry = new Masonry('.masonry-grid', {
        itemSelector: '.masonry-grid-item',
        columnWidth: itemWidth
    });
};

export {
    initMasonry
};
